// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3pQRr","col":"styles_col__5qEoO"};